import { MySiteRestService } from '@nuskin/my-site-api';
import { FormWrapper } from '@nuskin/my-site/src/my-site-app/form-wrapper/form-wrapper';
import { BundleUpdateCreate } from '@nuskin/my-site/src/my-site-app/forms/bundle-update-create/bundle-update-create';
import { ProductBundles } from '@nuskin/my-site/src/my-site-app/forms/forms';
import { UserService } from '@nuskin/ns-account';
import { nuskin, RunConfigService, StringService, TdcStrings } from '@nuskin/ns-util';
import '@polymer/iron-icon/iron-icon.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import './content-section-overlay/content-section-overlay';
import { LogoAndProfilePhoto } from './forms/logo-and-profile-photo/logo-and-profile-photo';
import './modals/modals';
import template from './my-site-app.html';
import { MySitePreview } from './my-site-preview/my-site-preview';
import { MySiteSpinner } from './my-site-spinner/my-site-spinner';
import './sidebar-menu/sidebar-menu';
import { SidebarMenu } from './sidebar-menu/sidebar-menu';

export const TOASTER_ACTIONS = {
    copyUrl: '',
    noBaseSku: ''
}

export const SCREEN_TYPE = {
    desktop: '',
    tablet: '',
    phone: ''
}

export const PREDICTIVE_SEARCH_LIMIT = 12;

// shared function used to overwrite paper radio button styles
export function OverwritePaperRadioButtonStyles(rb) {
    rb.$.offRadio.style.borderWidth = '1px';
    try {
        let styleSheet = rb.shadowRoot.styleSheets[0];
        if (styleSheet.addRule)
            styleSheet.addRule(':host([checked]) #onRadio', 'transform: scale(0.68)');
        else
            styleSheet.insertRule(':host([checked]) #onRadio { transform: scale(0.68) }');
    } catch (err) {
        console.log('ERROR: failed overwriting styles for paper-radio-button')
    }
}

/** @customElement
 * @polymer
 */

export class MySiteApp extends PolymerElement {

    constructor() {
        super();

        console.log(MySiteSpinner.is + 'is here!')

        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);

        TOASTER_ACTIONS.copyUrl = this.content.editStoreUrlFormCopySuccess;
        TOASTER_ACTIONS.noBaseSku = this.content.bundlesFormProductsNoBaseSku;

        SCREEN_TYPE.desktop = this.desktop = this.content.mySitePreviewScreenDesktop;
        SCREEN_TYPE.tablet = this.tablet = this.content.mySitePreviewScreenTablet;
        SCREEN_TYPE.phone = this.phone = this.content.mySitePreviewScreenPhone;

        this.set('showPriceType', this.content.allowPriceTypeWRTL && this.content.allowPriceTypeWWHL)

        this.previewOptions = ['100%', '75%', '50%'];

        this.screenTypeOptions = [
            SCREEN_TYPE.desktop,
            SCREEN_TYPE.tablet,
            SCREEN_TYPE.phone
        ];

        this.isDesktop = () => this.screenType === this.screenTypeOptions.find(item => item.toLowerCase() === SCREEN_TYPE.desktop.toLowerCase())
        this.isTablet = () => this.screenType === this.screenTypeOptions.find(item => item.toLowerCase() === SCREEN_TYPE.tablet.toLowerCase())
        this.isPhone = () => this.screenType === this.screenTypeOptions.find(item => item.toLowerCase() === SCREEN_TYPE.phone.toLowerCase())

        this.screenType = this.screenTypeOptions.desktop;

        this.desktopWidth = 1024;
        this.tabletWidth = 768;
        this.mobileWidth = 320;
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'my-site-app';
    }

    static get properties() {
        return {
            selectedSidebarPage: {
                type: String,
                value: SidebarMenu.is,
                observer: '_doSlidingAnimation'
            },
            mySiteData: {
                notify: true
            },
            isMobile: {
                type: Boolean
            },
            animationDuration: {
                type: Number,
                value: 500 // match the css transition
            },
            screenType: {
                type: String,
                notify: true,
                observer: '_screenTypeObserver'
            },
            currentZoom: {
                type: Number,
                value: 1,
                notify: true
            },
            currentLanguage: {
                type: String,
                notify: true,
                observer: '_handleLanguageChange'
            },
            currentMarket: {
                type: String,
                notify: true,
                observer: '_handleMarketChange'
            },
            marketsAndLanguages: {
                type: Object
            },
            currentForm: {
                type: String
            },
            iframeLoading: {
                observer: '_handleIframeLoading'
            },
            commonStrings: {
                type: Array,
                notify: true
            },
            subdomain: {
                type: String
            },
            fullProductCatalogFormVisibility: {
                type: Boolean,
                notify: true
            },
            showPriceType: Boolean
        };
    }

    async ready() {
        super.ready();

        this.runConfig = RunConfigService.getRunConfig();

        let commonStrings = await StringService.getStrings([
            { key: "fieldRequired", dflt: "" }
        ]);

        this.set('commonStrings', commonStrings);

        this.marketsAndLanguages = await MySiteRestService.getEnabledMarketsAndLanguages();
        this.currentMarket = this.runConfig.country;
        this.currentLanguage = this.runConfig.language;

        this.$.storefrontDrawer.addEventListener('opened-changed', this._handleDrawerTapOut.bind(this));
        this.addEventListener('on-menu-item-click', this._handleMenuItemClick.bind(this));
        this.addEventListener('show-unsaved-changes-modal', this._showUnsavedChangesModal);
        this.$.previewPercent.addEventListener('selected-changed', this._handlePreviewPercentChange.bind(this));
        this.$.screenType.addEventListener('selected-changed', this._handleScreenTypeChange.bind(this));
        this.$.menuPages.addEventListener('iron-deselect', this._keepDeselectedElementVisible.bind(this));
        this.$.welcomeModal.$.modalContainer.addEventListener('opened-changed', this._handleWelcomModalClose.bind(this));
        window.addEventListener('resize', this._handleDesktopViewOption.bind(this));
        window.addEventListener('load', this._handleDesktopViewOption.bind(this));
        this.$.iframe.addEventListener('load', this._handleIframeLoad.bind(this));
        this.addEventListener('my-site-toaster', this._handleToaster.bind(this));
        this.$.mySiteSidebarWrapper.addEventListener('scroll', this._handleAutoScroll.bind(this))

        // api
        try {
            this.currentUser = await UserService.getUser();
        } catch (err) {
            console.log(err)
        }
        // do login redirect only if not in AEM wrapper
        let isAEM = !!window.parent.document.getElementsByClassName('cq-frame').length;
        if (!isAEM && (!this.currentUser || !this.currentUser.id)) {
            if (!this.currentUser) nuskin.events.publish(nuskin.events.authentication.REQUEST_FOR_LOGIN);
        }

        if (!this.currentUser.isDistributor()) {
            window.location.replace('/content/nuskin/en_US/mysite/mysite-no-permission-error.html')
        }

        // icons adjustments
        try {
            this.$.iconDesktop.shadowRoot.querySelector('svg').setAttribute('viewBox', "0,0,32,20")
            this.$.iconTablet.shadowRoot.querySelector('svg').setAttribute('viewBox', "0,0,30,25")
            this.$.iconPhone.shadowRoot.querySelector('svg').setAttribute('viewBox', "0,0,20,20")
        } catch (err) { console.log(err) }

        this.set('spinnerCaption', this.content.mySiteLoadingSpinner || 'Loading...');

        this.setPreviewUrl(true);

        // for DEV purposes: Open desired menu on page load
        // this.dispatchEvent(new CustomEvent('on-menu-item-click', {detail: {item:'contact-information'},composed: true, bubbles: true,}))
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        this.$.storefrontDrawer.removeEventListener('opened-changed', this._handleDrawerTapOut.bind(this))
        this.removeEventListener('on-menu-item-click', this._handleMenuItemClick.bind(this));
        this.removeEventListener('show-unsaved-changes-modal', this._showUnsavedChangesModal);
        this.$.previewPercent.removeEventListener('selected-changed', this._handlePreviewPercentChange.bind(this))
        this.$.screenType.removeEventListener('selected-changed', this._handleScreenTypeChange.bind(this))
        this.$.menuPages.removeEventListener('iron-deselect', this._keepDeselectedElementVisible);
        this.$.welcomeModal.$.modalContainer.removeEventListener('opened-changed', this._handleWelcomModalClose.bind(this));
        window.removeEventListener('resize', this._handleDesktopViewOption.bind(this))
        window.removeEventListener('load', this._handleDesktopViewOption.bind(this));
        this.$.iframe.removeEventListener('load', this._handleIframeLoad.bind(this));
        this.removeEventListener('my-site-toaster', this._handleToaster.bind(this));
    }

    async _handleIframeLoading(newVal) {
        this.$.mobileDrawerToggle.className = newVal ? 'hidden' : ''
    }

    _handleAutoScroll(e) {
        let scrollTop = e.currentTarget.scrollTop;
        if (scrollTop === 0 && this.animating && this.scrollResolver)
            this.scrollResolver();
    }

    setPreviewUrl(useDefaultData) {
        let isAEM = !!window.parent.document.getElementsByClassName('cq-frame').length;
        if (isAEM) return;

        let lng = useDefaultData ? this.runConfig.language : this.currentLanguage;
        let ctry = useDefaultData ? this.runConfig.country : this.currentMarket;

        if (!this.previewPage || this.previewPage && this.previewPage.indexOf(`${lng}_${ctry}`) === -1) {
            this.set('iframeLoading', true);
            this.previewPage = `${this.runConfig.baseUrl}/content/nuskin/${lng}_${ctry}/tools/my-site-preview.html`;
        }
    }

    _handleToaster(e) {
        let options = e.detail;

        this.set('toasterMessage', options.message)
        this.set('toasterIcon', 'nuskin:icon-' + options.icon)
        this.$.mySiteToaster.setAttribute('theme', options.theme);
        setTimeout(() => {
            this.$.mySiteToaster.removeAttribute('opened')
        }, 3200);

        this.$.mySiteToaster.setAttribute('opened', true)
    }

    async _handleLanguageChange() {
        let item;
        if (this.$.iframe.className.indexOf('hidden') === -1)
            this.$.iframe.className += ' hidden';
        await this.checkIfDataExists();
        this.setPreviewUrl();
        if (this.currentMarket && this.marketsAndLanguages && this.marketsAndLanguages[this.currentMarket] && this.marketsAndLanguages[this.currentMarket].languages) {
            item = this.marketsAndLanguages[this.currentMarket].languages.find(item => item.code === this.currentLanguage);
        }
        if (item)
            this.set('currentLanguageDisplay', item.displayName);
    }

    async _handleMarketChange(newVal, oldVal) {
        if (newVal === oldVal) return;

        this.currentLanguage = this.marketsAndLanguages[newVal].defaultLocale
            ? this.marketsAndLanguages[newVal].defaultLocale.defaultLanguageCode
            : ''

        if (this.$.iframe.className.indexOf('hidden') === -1)
            this.$.iframe.className += ' hidden';
        await this.checkIfDataExists();
        this.setPreviewUrl();
    }

    async checkIfDataExists(mySiteData) {
        mySiteData = mySiteData || this.mySiteData
        if (!mySiteData) return;
        if (!mySiteData.storefront[this.subdomain][this.currentMarket]
            || !mySiteData.storefront[this.subdomain][this.currentMarket].lang
            || !mySiteData.storefront[this.subdomain][this.currentMarket].lang[this.currentLanguage]) {
            this.set('iframeLoading', true);
            await MySiteRestService.initialSponsorSetup(this.subdomain, mySiteData, '', null, this.currentMarket, this.currentLanguage);
            this.set('iframeLoading', false);
        }
    }

    async _handleIframeLoad() {
        if (this.$.iframe.src)
            this.set('iframeLoading', false);

        await this.getMySiteData();

        if (this.currentForm && this.currentForm !== SidebarMenu.is)
            this.dispatchEvent(new CustomEvent('on-menu-item-click', {
                detail: { item: this.currentForm },
                composed: true,
                bubbles: true
            }));
    }

    async getMySiteData() {
        return MySiteRestService.getSponsorData(this.currentUser.id)
            .then(async mySiteData => {
                if (!mySiteData || mySiteData && !mySiteData.storefront) {
                    this.showWelcomeModal();
                    return;
                } else {
                    this.set('subdomain', Object.keys(mySiteData.storefront)[0]);

                    let market = mySiteData.storefront[this.subdomain][this.currentMarket];
                    if (!market) {
                        await this.checkIfDataExists(mySiteData);
                    }

                    let language = mySiteData.storefront[this.subdomain][this.currentMarket].lang[this.currentLanguage];
                    if (!language) {
                        await this.checkIfDataExists(mySiteData);
                    }
                    // if we had to add data to FB then retreive it again
                    if (!market || !language) {
                        mySiteData = await MySiteRestService.getSponsorData(this.currentUser.id);
                        market = mySiteData.storefront[this.subdomain][this.currentMarket];
                        language = mySiteData.storefront[this.subdomain][this.currentMarket].lang[this.currentLanguage];
                    }
                    // refresh default bundles
                    if (market.showDefaultBundles) {
                        let bundles = await MySiteRestService.getMarketFeaturedBundle();
                        market.bundles = [
                            {
                                id: 0,
                                skus: bundles
                            }
                        ];

                        let mySiteTranslationsTdc = await TdcStrings.getStrings('mysite/mysite-home', this.currentLanguage, this.currentMarket) || {};
                        language.bundlesInfo = [
                            {
                                bundle_id: 0,
                                name: mySiteTranslationsTdc.featuredBundleTitle || '',
                                about: mySiteTranslationsTdc.defaultBundlesMessage || ''
                            }
                        ];
                    }

                    // refresh featured products
                    if (market.showDefaultProducts) {
                        let products = await MySiteRestService.getMarketFeaturedProducts();
                        market.products = products.map(item => item.sku);
                    }

                    //filter out bad data (sometimes users end up with NULL bundles. Was not able to reproduce the issue. But this is a work around)
                    market.bundles = market.bundles || []
                    market.bundles = market.bundles.filter(bundle => bundle)

                    // prefill language specific data with defaults if needed;
                    language.bundlesInfo = this.assembleBundlesInfo(market, this.currentLanguage, language.bundlesInfo) || [];
                    language.storeName = this.getLanguageSpecificContent('storeName', market.lang, this.currentLanguage);
                    language.aboutYourStore = this.getLanguageSpecificContent('aboutYourStore', market.lang, this.currentLanguage);
                    language.purchaseMessage = this.getLanguageSpecificContent('purchaseMessage', market.lang, this.currentLanguage);
                    language.aboutProducts = this.getLanguageSpecificContent('aboutProducts', market.lang, this.currentLanguage);

                    // create new object every time to trigger `change` event
                    this.set('mySiteData', Object.assign({}, mySiteData));
                }
            })
            .catch(err => {
                console.log(err)
                throw new Error('Oops! something went wrong during store initialization');
            });
    }

    getLanguageSpecificContent(prop, languages, currentLanguage) {
        let curLang = languages[currentLanguage]
        let value = curLang[prop] || '';

        if (!value) {
            let remainingLanguages = Object.keys(languages).filter(l => l !== currentLanguage);
            remainingLanguages.forEach(lang => {
                if (languages[lang].default)
                    value = languages[lang][prop];
            });
        }

        return value;
    }

    // gets bundles info and populates missing info in the market with default values. Ex: if bundle X was set only under chinese language, and user is previewing
    // site for spanish language, instead of seeing nothing, user will see chinese content.
    assembleBundlesInfo(market, currentLanguage, bundlesInfo) {
        if (!bundlesInfo) return;
        let result = [];
        let bundles = market.bundles || [];
        let languages = market.lang;
        let remainingLanguages = Object.keys(languages).filter(l => l !== currentLanguage);

        bundles.forEach(bundle => {
            let bi = bundlesInfo.find(item => item.bundle_id === bundle.id);
            // if not translation available under current language, find default one
            if (!bi) {
                remainingLanguages.forEach(lang => {
                    languages[lang].bundlesInfo = languages[lang].bundlesInfo || []
                    languages[lang].bundlesInfo.forEach(bundInf => {
                        if (bundle.id === bundInf.bundle_id) bi = bundInf;
                    });
                });

                bi = bi || {
                    id: bundle.id,
                    name: this.mySiteHomeTranslations.tdc_featuredBundleTitle || '',
                    about: this.mySiteHomeTranslations.tdc_defaultBundlesMessage || ''
                }
            }

            result.push(bi);
        });
        return result;
    }

    _handleDesktopViewOption(e) {
        if (this.$.contentContainer.clientWidth < this.tabletWidth) {
            if (this.$.iconDesktop.parentNode.className.indexOf(' disabled') === -1)
                this.$.iconDesktop.parentNode.className += ' disabled';
            this.disableDesktopScreen = true;
            let screenType = this.isDesktop() ? SCREEN_TYPE.tablet : this.screenType;
            if (screenType !== this.screenType)
                this.screenType = screenType
        } else {
            this.disableDesktopScreen = false;
            this.$.iconDesktop.parentNode.className = this.$.iconDesktop.parentNode.className.split(' disabled').join('');

            if (!this.isDesktop())
                this.screenType = SCREEN_TYPE.desktop;
        }

        if (e.currentTarget.innerWidth <= this.desktopWidth && !this.isDesktop()) {
            this.screenType = SCREEN_TYPE.desktop;
        }
        let selected = this.screenTypeOptions.findIndex(item => item.toLowerCase() === this.screenType);
        if (selected !== this.$.screenType.selected)
            this.$.screenType.selected = selected;
    }

    _handleDrawerTapOut(e) {
        let opened = e.detail.value;

        if (!opened) {
            // overwrite default behavior that just toggles the drawer on `#scrim` click
            // let formWrapper = this.$.menuPages.querySelector(`[name=${this.$.menuPages.selected}] ${FormWrapper.is}`);
            // if(formWrapper && formWrapper.formWasUpdatedButNotSaved) {
            // this.$.storefrontDrawer.opened = true;
            //   formWrapper.goBack(true);
            //   return;
            // }
            this.overlayClick();
            // remove myte class to allow scrolling
            this.className = this.className.split(/\s?mute/).join('');
        } else {
            if (this.isMobile && this.className.indexOf('mute') === -1)
                this.className += ' mute';
        }

        if (this.isMobile && !opened && this.$.menuPages.selected !== SidebarMenu.is) {
            this.$.menuPages.selected = SidebarMenu.is;
            this.keepMenuOpen = false;
        }
    }

    goBackBack() {
        window.history.back();
    }

    _handleWelcomModalClose(e) {
        if (!e.detail.value) // if closed
            this.getMySiteData();
    }

    _handlePreviewPercentChange(e) {
        let index = e.detail.value;
        this.set('currentZoom', !index ? 1 : (index === 1 ? 0.75 : 0.5));
        let preview = this.$.iframe.contentDocument.querySelector(MySitePreview.is);
        if (!preview) return
        preview.className = preview.className.split(/\s?scale-\d+/g).join('');
        preview.className += ` scale-${100 - 25 * index}`;

        // GA
        if (!this.iframeLoading)
            try {
                nuskin.events.publish(nuskin.events.mySite.PREVIEW_HEADER, {
                    mySite: {
                        action: 'preview percent',
                        zoom: this.currentZoom
                    }
                });
            } catch (err) { console.log(err) }
    }

    _handleScreenTypeChange(e) {
        // GA
        if (e.detail.value < 0) return;
        if (!this.iframeLoading)
            try {
                nuskin.events.publish(nuskin.events.mySite.PREVIEW_HEADER, {
                    mySite: {
                        action: 'screen type',
                        screen: this.screenTypeOptions[e.detail.value]
                    }
                });
            } catch (err) { console.log(err) }
        this.set('screenType', this.screenTypeOptions[e.detail.value].toLowerCase());
    }

    async _keepDeselectedElementVisible(e) {
        if (this.isMobile) return; // skip sliding animation for mobile
        if (e.target.id === 'menuPages') {
            e.target.querySelector(`[name=${this.currentForm}]`).style.opacity = 0;
            e.detail.item.className += ' iron-selected';
        }
    }

    async _doSlidingAnimation(newVal, oldVal) {
        if (this.isMobile) return; // skip sliding animation for mobile

        this.animating = true;

        // check if sidebar is scolled down. if so, scroll to top first, then do sliding animation
        if (this.$.mySiteSidebarWrapper.scrollTop) {
            this.scrollingToTop = new Promise((resolve) => {
                this.scrollResolver = resolve;
            });

            this.$.mySiteSidebarWrapper.scroll({
                top: 0,
                behavior: 'smooth'
            });

            await this.scrollingToTop;
        }

        if (oldVal && newVal) {

            // deside direction (which form slides left to right, which right to left)
            // usually SidebarMenu comes from left, and forms from right. But there is an exception
            // when user goes 3 levels deep: SidebarMenu -> ProductBundles -> BundleUpdateEdit.

            let sidebarMenuPage = newVal === SidebarMenu.is || (newVal === ProductBundles.is && oldVal === BundleUpdateCreate.is)
                ? newVal
                : oldVal;
            let formPage = sidebarMenuPage === newVal
                ? oldVal
                : newVal;

            let pages = this.$.menuPages.children;
            this.$.menuPages.querySelector(`[name=${this.currentForm}]`).style.opacity = 1;

            // Run the animation on the sidedabar menu page
            pages[sidebarMenuPage].className += ` left-slide-${sidebarMenuPage === newVal ? 'in' : 'out'}`;
            // Run the animation on the form page
            pages[formPage].className += ` right-slide-${formPage === newVal ? 'in' : 'out'}`;

            // wait until menu scrolls up first
            await this.scrollingToTop;

            // cleanup classes for animated pages
            setTimeout(() => {
                let regex3 = /\s?iron-selected/;
                pages[oldVal].className = pages[oldVal].className.split(regex3).join('');

                let regex1 = /\s?left-slide-\w+/;
                pages[sidebarMenuPage].className = pages[sidebarMenuPage].className.split(regex1).join('');
                let regex2 = /\s?right-slide-\w+/;
                pages[formPage].className = pages[formPage].className.split(regex2).join('');

                // re-enable scrolling
                window.onwheel = null;
                this.animating = false;
            }, this.animationDuration - 10); // Give cleanup 10ms buffer to avoid occasional weird visual behavior
        }
    }

    _handleScreenTypeClick(e) {
        if (this.disableDesktopScreen && e.currentTarget.dataset.name === 'desktop') return;
        let type;

        switch (e.currentTarget.dataset.name) {
            case 'desktop':
                type = SCREEN_TYPE.desktop.toLowerCase(); break;
            case 'tablet':
                type = SCREEN_TYPE.tablet.toLowerCase(); break;
            case 'phone':
                type = SCREEN_TYPE.phone.toLowerCase(); break;
        }
        this.set('screenType', type);
    }

    _screenTypeObserver(newVal) {
        let icons = this.$.screenTypeIcons.children;
        icons[0].className = icons[0].className.split(' active').join('');
        icons[1].className = icons[1].className.split(' active').join('');
        icons[2].className = icons[2].className.split(' active').join('');

        let type;

        this.$.previewPercent.removeAttribute('disabled')

        switch (newVal.toLowerCase()) {
            case SCREEN_TYPE.desktop.toLowerCase():
                type = 'desktop'; break;
            case SCREEN_TYPE.tablet.toLowerCase():
                type = 'tablet'; break;
            case SCREEN_TYPE.phone.toLowerCase():
                type = 'phone';
                this.$.previewPercent.selected = 0;
                this.$.previewPercent.setAttribute('disabled', true)
                break;
        }

        let elem = this.$.screenTypeIcons.querySelector(`[data-name=${type}]`);

        elem.className += ' active';

        let className;

        switch (newVal) {
            case SCREEN_TYPE.desktop.toLowerCase():
                className = 'desktop'; break;
            case SCREEN_TYPE.tablet.toLowerCase():
                className = 'tablet'; break;
            case SCREEN_TYPE.phone.toLowerCase():
                className = 'phone'; break;
        }

        this.$.screenType.selected = this.screenTypeOptions.findIndex(item => item.toLowerCase() === newVal.toLowerCase());

        this.$.iframe.className = this.$.iframe.className.split(/\s?tablet-view|\s?phone-view|\s?desktop-view/g).join('');
        if (className)
            this.$.iframe.className += ` ${className}-view`;

        // Unique case for logos form. On screen type change logo overlays get jacked up.
        if (this.currentForm === LogoAndProfilePhoto.is)
            this.dispatchEvent(new CustomEvent('on-menu-item-click', {
                detail: { item: SidebarMenu.is },
                composed: true,
                bubbles: true
            }));
    }

    _handleMenuItemClick(e) {
        this.isMobile = this.isMobile || e.detail.mobile;
        if (this.isMobile && e.detail.item !== SidebarMenu.is) {
            this.$.storefrontDrawer.open();
            this.keepMenuOpen = false;
        }

        if ((this.isMobile && e.detail.item === SidebarMenu.is || e.detail.toggleDrawer) && !this.keepMenuOpen) {
            this.$.storefrontDrawer.close();
            this.isMobile = false;
        }
        this.$.menuPages.select(e.detail.item);
        // resets form data (discards unsaved changes)
        this.getMySiteData(true);
    }

    _toggleDrawerMobile() {
        this.isMobile = true;
        this.keepMenuOpen = true;
        this.$.storefrontDrawer.toggle();
    }

    showWelcomeModal() {
        this.$.welcomeModal.$.modalContainer.toggle();
    }

    _showUnsavedChangesModal() {
        this.$.saveChangesModal.$.modalContainer.toggle();
    }

    overlayClick() {
        if (this.animating) return;

        let activeForm = this.$.menuPages.selected;
        let wrapper = this.$.menuPages.querySelector(`.wrapper[name=${activeForm}] ${FormWrapper.is}`);
        if (wrapper)
            wrapper.goBack(true);
    }

}

customElements.define(MySiteApp.is, MySiteApp);